import {
  ChartBarBig,
  ChartColumn,
  ChartLine,
  ChartPie,
  ChartScatter,
  Table2,
  type LucideIcon
} from 'lucide-react';
import {ToggleGroup, ToggleGroupItem} from '@kroll-resolver-crisp/ui-components-react';
import {type ReportBlockType} from '@/api/reporting';

export type ViewName = Exclude<ReportBlockType, 'kpi' | 'matrix'>;

const VIEWS: Record<ViewName, {label: string; icon: LucideIcon}> = {
  line_chart: {label: 'Line chart', icon: ChartLine},
  bar_chart: {label: 'Bar chart', icon: ChartColumn},
  scatter_chart: {label: 'Scatter chart', icon: ChartScatter},
  pie_chart: {label: 'Pie chart', icon: ChartPie},
  linear_bar_chart: {label: 'Linear bar', icon: ChartBarBig},
  table: {label: 'Table', icon: Table2}
};

// The button set at the right of a block's heading: one icon per view the block offers.
export function ViewSwitcher({
  views,
  value,
  onChange
}: {
  readonly views: readonly ViewName[];
  readonly value: ViewName;
  readonly onChange: (view: ViewName) => void;
}) {
  return (
    <ToggleGroup
      variant="outline"
      spacing={0}
      size="sm"
      aria-label="View"
      value={[value]}
      onValueChange={(next) => {
        // A toggle group lets the active item be pressed off; a block always shows one view.
        const view = next[0] as ViewName | undefined;
        if (view !== undefined) {
          onChange(view);
        }
      }}>
      {views.map((view) => {
        const {label, icon: Icon} = VIEWS[view];
        return (
          <ToggleGroupItem key={view} value={view} aria-label={label}>
            <Icon />
          </ToggleGroupItem>
        );
      })}
    </ToggleGroup>
  );
}
